import gql from "graphql-tag";

export const SEND_VISITOR_INVOICE = gql`
  mutation ($invoiceId: ID!) {
    sendVisitorInvoice(invoiceId: $invoiceId)
  }
`;
